import {
  MaterialCommunityIcons,
  MaterialIcons,
  Octicons,
} from "@expo/vector-icons";
import { Tabs } from "expo-router";
import React, { useEffect, useState } from "react";
import { View, Dimensions } from "react-native";

import DashboardMenu from "@/components/menu/DashboardMenu";

import "reflect-metadata";

export default function RoutesManagementLayout() {
  const [isLgDevice, setIsLgDevice] = useState(false);

  useEffect(() => {
    const updateLayout = () => {
      const screenDimensions = Dimensions.get("window");
      setIsLgDevice(screenDimensions.width > 1024);
    };

    updateLayout();

    const subscription = Dimensions.addEventListener("change", updateLayout);

    return () => subscription.remove();
  }, []);

  return (
    <>
      <View className="grow bg-white1">
        <View className="w-full h-full lg:flex-row">
          {isLgDevice && (
            <View className="z-50">
              <DashboardMenu />
            </View>
          )}
          <View className="flex-grow px-4 lg:px-10 lg:py-6">
            <Tabs screenOptions={{ headerShown: false }}>
              <Tabs.Screen
                name="dashboard"
                options={{
                  title: "Customers",
                  ...(isLgDevice
                    ? {
                        tabBarStyle: { display: "none" },
                        href: null,
                      }
                    : {
                        tabBarIcon: ({ color, size }) => (
                          <MaterialIcons
                            name="people-outline"
                            color={color}
                            size={size}
                          />
                        ),
                      }),
                }}
              />
              <Tabs.Screen
                name="[id]"
                options={{
                  tabBarStyle: { display: "none" },
                  title: "Customer Page",
                  href: null,
                }}
              />
              <Tabs.Screen
                name="transactions"
                options={{
                  title: "Transactions",
                  ...(isLgDevice
                    ? {
                        tabBarStyle: { display: "none" },
                        href: null,
                      }
                    : {
                        tabBarIcon: ({ color, size }) => (
                          <MaterialIcons
                            name="attach-money"
                            color={color}
                            size={size}
                          />
                        ),
                      }),
                }}
              />
              <Tabs.Screen
                name="counterparties"
                options={{
                  title: "Counterparties",
                  ...(isLgDevice
                    ? {
                        tabBarStyle: { display: "none" },
                        href: null,
                      }
                    : {
                        tabBarIcon: ({ color, size }) => (
                          <Octicons
                            name="arrow-switch"
                            color={color}
                            size={size}
                          />
                        ),
                      }),
                }}
              />
              <Tabs.Screen
                name="counterparty/[id]"
                options={{
                  tabBarStyle: { display: "none" },
                  title: "Counterparty Page",
                  href: null,
                }}
              />
              <Tabs.Screen
                name="applications"
                options={{
                  title: "Applications",
                  ...(isLgDevice
                    ? {
                        tabBarStyle: { display: "none" },
                        href: null,
                      }
                    : {
                        tabBarIcon: ({ color, size }) => (
                          <MaterialCommunityIcons
                            name="file-document-outline"
                            color={color}
                            size={size}
                          />
                        ),
                      }),
                }}
              />
            </Tabs>
          </View>
        </View>
      </View>
    </>
  );
}
